'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const React = require('react');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_display_Tooltip_Tooltip = require('../../display/Tooltip/Tooltip.cjs.js');
const components_forms_TextInput_TextInput = require('../TextInput/TextInput.cjs.js');
const hooks_useCopyToClipboard = require('../../../hooks/useCopyToClipboard.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_tbbib_1";
const copyButton = "_copy-button_tbbib_6";
const tooltip = "_tooltip_tbbib_22";
const styles = {
	root: root,
	copyButton: copyButton,
	tooltip: tooltip
};

const CopyTextInput = (_a) => {
  var { size = "medium", type = "text", value } = _a, otherProps = tslib_es6.__rest(_a, ["size", "type", "value"]);
  const props = Object.assign({
    size,
    type,
    value
  }, otherProps);
  const [didCopy, handleCopyText] = hooks_useCopyToClipboard.useCopyToClipboard(value);
  const onClickCopy = (event) => {
    event.preventDefault();
    handleCopyText();
  };
  const renderCopyButton = ({ iconSize }) => {
    const ariaLabel = didCopy ? `"${value}" copied to the clipboard` : `Copy "${value}" to the clipboard`;
    return React__default.default.createElement(
      "button",
      { "aria-hidden": !value, "aria-label": ariaLabel, className: styles.copyButton, color: "primary", disabled: !value, onClick: onClickCopy, type: "button", "data-zds": true },
      React__default.default.createElement(components_display_Icon_Icon.Icon, { isBlock: true, name: "actionCopy", size: iconSize }),
      React__default.default.createElement(
        "div",
        { className: styles.tooltip, "data-hidden": !didCopy, "data-zds": true },
        React__default.default.createElement(components_display_Tooltip_Tooltip.Tooltip, { "aria-hidden": true, position: "southeast" }, "Copied to clipboard!")
      )
    );
  };
  return React__default.default.createElement(
    "div",
    { className: styles.root, "data-zds": true },
    React__default.default.createElement(components_forms_TextInput_TextInput.TextInput, Object.assign({}, props, { "aria-hidden": true, disabledText: value ? "" : "Disabled", isDisabled: !value, isReadonly: Boolean(value), isFocusable: false, renderIconAfter: renderCopyButton }))
  );
};

exports.CopyTextInput = CopyTextInput;
//# sourceMappingURL=CopyTextInput.cjs.js.map
